import React from 'react';
import PropTypes from 'prop-types';
import { Button, BaseModal, LoadingSpinner, dateTimeTranslate } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { Notes, useOktaQuery } from '../../data';

const ViewPlayerAuthoredNoteModal = ({ show, container, note, onHide, customTitle }) => {
    const { t: translate } = useTranslation();
    const { data: history, isLoading: loadingHistory } = useOktaQuery(
        ['history', note.NoteID],
        (t) => Notes.getReportNoteHistory(t, note),
    );

    return (
        <BaseModal size="md" container={container} show={show} onHide={onHide}>
            <BaseModal.Header>
                {translate('components.notes.notes')}: {customTitle || note.Pitcher?.FullName || note.Batter?.FullName || translate('components.notes.my-notes')}
            </BaseModal.Header>
            <BaseModal.Body className="left">
                <div className="mb-1" dangerouslySetInnerHTML={{ __html: note.Note }} />
                <div className="text-right text-muted">{dateTimeTranslate(translate, note.LastUpdateDate)}</div>
                {loadingHistory && <LoadingSpinner />}
                {history?.map((noteVersion) => (
                    <div key={noteVersion.NoteID}>
                        <hr />
                        <div className="mt-1 mb-1" dangerouslySetInnerHTML={{ __html: noteVersion.Note }} />
                        <div className="text-right text-muted">{dateTimeTranslate(translate, noteVersion.LastUpdateDate)}</div>
                    </div>
                ))}
            </BaseModal.Body>
            <BaseModal.Footer>
                <Button variant="secondary" onClick={onHide}>{translate('common.close')}</Button>
            </BaseModal.Footer>
        </BaseModal>
    );
};

ViewPlayerAuthoredNoteModal.propTypes = {
    note: PropTypes.shape({
        NoteID: PropTypes.number,
        Note: PropTypes.string,
        Batter: PropTypes.shape({ PlayerID: PropTypes.number, FullName: PropTypes.string }),
        Pitcher: PropTypes.shape({ PlayerID: PropTypes.number, FullName: PropTypes.string }),
        LastUpdateDate: PropTypes.string,
    }).isRequired,
    onHide: PropTypes.func.isRequired,
    customTitle: PropTypes.string,
    show: PropTypes.bool,
    container: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

ViewPlayerAuthoredNoteModal.defaultProps = {
    show: false,
    container: undefined,
    customTitle: undefined,
};

export default ViewPlayerAuthoredNoteModal;
